import React from "react";
import {
  Button,
  Badge,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  Check,
  X,
  ArrowCounterclockwise,
  ExclamationTriangleFill,
} from "react-bootstrap-icons";

export function Actions({
  contract,
  unassigned,
  busy,
  errored,
  onApprove,
  onDecline,
  onReset,
}) {
  if (busy) {
    return (
      <div
        className="d-flex align-items-center justify-content-sm-end"
        style={{ minHeight: 31 }}
      >
        <Spinner
          animation="border"
          size="sm"
          className="text-secondary"
          role="status"
        >
          <span className="visually-hidden">Saving…</span>
        </Spinner>
      </div>
    );
  }

  if (contract.commissionStatus === "Approved") {
    return <Resolved variant="success" label="Approved" onReset={onReset} />;
  }
  if (contract.commissionStatus === "Declined") {
    return <Resolved variant="danger" label="Declined" onReset={onReset} />;
  }

  // pending
  return (
    <div className="d-flex align-items-center gap-2 justify-content-sm-end">
      {errored && (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Update failed, please try again.</Tooltip>}
        >
          <span
            className="text-danger d-inline-flex align-items-center"
            role="img"
            aria-label="Update failed, please try again"
          >
            <ExclamationTriangleFill size={16} />
          </span>
        </OverlayTrigger>
      )}
      <Button
        variant="outline-danger"
        size="sm"
        onClick={onDecline}
        className="d-inline-flex align-items-center gap-1 fw-medium"
      >
        <X size={16} />
        Decline
      </Button>
      {!unassigned && (
        <Button
          variant="success"
          size="sm"
          onClick={onApprove}
          className="d-inline-flex align-items-center gap-1 fw-semibold"
        >
          <Check size={16} />
          Approve
        </Button>
      )}
    </div>
  );
}

function Resolved({ variant, label, onReset }) {
  return (
    <div className="d-flex align-items-center gap-2 justify-content-sm-end">
      <Badge
        bg={`${variant}-subtle`}
        text={`${variant}`}
        className="px-3 py-2 fw-medium"
      >
        {label}
      </Badge>
      <Button
        variant="light"
        size="sm"
        onClick={onReset}
        title="Reset"
        className="d-inline-flex align-items-center justify-content-center text-secondary border-0"
        style={{ width: 32, height: 32, padding: 0 }}
      >
        <ArrowCounterclockwise size={16} />
      </Button>
    </div>
  );
}
